"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMonthDayChain = exports.monthDayFns = void 0;
const ES = __importStar(require("../ecmascript"));
const dateFns_1 = require("./dateFns");
const format_1 = __importDefault(require("../format"));
exports.monthDayFns = {
    fromNumbers(month, day) {
        month = ES.ToIntegerThrowOnInfinity(month);
        day = ES.ToIntegerThrowOnInfinity(day);
        // Note: if the arguments are not passed,
        //       ToIntegerThrowOnInfinity(undefined) will have returned 0, which will
        //       be rejected by RejectISODate in CreateTemporalMonthDaySlots. This
        //       check exists only to improve the error message.
        if (arguments.length < 2) {
            throw new RangeError('missing argument: isoMonth and isoDay are required');
        }
        return ES.CreateTemporalMonthDay(month, day);
    },
    isValid(monthDay) {
        return ES.IsTemporalMonthDay(monthDay);
    },
    assertIsValid(monthDay) {
        if (!ES.IsTemporalMonthDay(monthDay))
            throw new TypeError('invalid receiver');
    },
    getDay(monthDay) {
        if (!ES.IsTemporalMonthDay(monthDay))
            throw new TypeError('invalid receiver');
        return ES.CalendarDay(monthDay);
    },
    getMonth(monthDay) {
        if (!ES.IsTemporalMonthDay(monthDay))
            throw new TypeError('invalid receiver');
        return ES.CalendarDay(monthDay);
    },
    with(monthDay, temporalMonthDayLike, options = undefined) {
        if (!ES.IsTemporalMonthDay(monthDay))
            throw new TypeError('invalid receiver');
        if (typeof temporalMonthDayLike !== 'object') {
            throw new TypeError('invalid argument');
        }
        if (temporalMonthDayLike.timeZone !== undefined) {
            throw new TypeError('with() does not support a timeZone property');
        }
        const props = ES.ToPartialRecord(temporalMonthDayLike, ['day', 'month', 'monthCode', 'year']);
        if (!props) {
            throw new TypeError('invalid month-day-like');
        }
        let fields = ES.ToTemporalMonthDayFields(ES.GetMonthDaySlots(monthDay));
        fields = ES.CalendarMergeFields(fields, props);
        fields = ES.ToTemporalMonthDayFields(fields);
        options = ES.GetOptionsObject(options);
        return ES.MonthDayFromFields(fields, options);
    },
    equals(monthDay, other) {
        if (!ES.IsTemporalMonthDay(monthDay))
            throw new TypeError('invalid receiver');
        other = ES.ToTemporalMonthDay(other);
        const slots1 = ES.GetMonthDaySlots(monthDay);
        const slots2 = ES.GetMonthDaySlots(other);
        for (const slot of ['month', 'day']) {
            const val1 = slots1[slot];
            const val2 = slots2[slot];
            if (val1 !== val2)
                return false;
        }
        return true;
    },
    toDate(monthDay, year) {
        if (!ES.IsTemporalMonthDay(monthDay))
            throw new TypeError('invalid receiver');
        year = ES.ToIntegerThrowOnInfinity(year);
        const { month, day } = ES.GetMonthDaySlots(monthDay);
        ES.RegulateISODate(year, month, day, 'reject');
        return ES.CreateTemporalDate(year, month, day);
    },
    getFields(monthDay) {
        if (!ES.IsTemporalMonthDay(monthDay))
            throw new TypeError('invalid receiver');
        return ES.GetMonthDaySlots(monthDay);
    },
    from(item, options = undefined) {
        options = ES.GetOptionsObject(options);
        if (ES.IsTemporalMonthDay(item)) {
            ES.ToTemporalOverflow(options); // validate and ignore
            const slots = ES.GetMonthDaySlots(item);
            return ES.CreateTemporalMonthDay(slots.month, slots.day);
        }
        return ES.ToTemporalMonthDay(item, options);
    },
    compare(one, two) {
        if (!ES.IsTemporalMonthDay(one))
            throw new TypeError('invalid receiver');
        if (!ES.IsTemporalMonthDay(two))
            throw new TypeError('invalid receiver');
        const oneSlots = ES.GetMonthDaySlots(one);
        const twoSlots = ES.GetMonthDaySlots(two);
        return ES.CompareISODate(1972, oneSlots.month, oneSlots.day, 1972, twoSlots.month, twoSlots.day);
    },
    format(monthDay, formatString) {
        if (!ES.IsTemporalMonthDay(monthDay))
            throw new TypeError('invalid receiver');
        return format_1.default(ES.GetMonthDaySlots(monthDay), formatString);
    },
    chain: buildMonthDayChain
};
function buildMonthDayChain(monthDay) {
    return {
        value() {
            return monthDay;
        },
        getDay() {
            return ES.buildChain(exports.monthDayFns.getDay(monthDay));
        },
        getMonth() {
            return ES.buildChain(exports.monthDayFns.getMonth(monthDay));
        },
        with(monthDayLike, options) {
            return buildMonthDayChain(exports.monthDayFns.with(monthDay, monthDayLike, options));
        },
        equals(other) {
            return ES.buildChain(exports.monthDayFns.equals(monthDay, other));
        },
        toDate(year) {
            return dateFns_1.buildDateChain(exports.monthDayFns.toDate(monthDay, year));
        },
        getFields() {
            return ES.buildChain(exports.monthDayFns.getFields(monthDay));
        },
        format(formatString) {
            return ES.buildChain(exports.monthDayFns.format(monthDay, formatString));
        }
    };
}
exports.buildMonthDayChain = buildMonthDayChain;
